import React from "react";
import { Fade } from "react-reveal";
import ScrollSpy from "react-ui-scrollspy";

import Profile from "../partials/About/Profile";
import Experience from "../partials/About/Experience";
import Training from "../partials/About/Training";
import Skills from "../partials/About/Skills";
import Education from "../partials/About/Education";

export default function About() {
  return (
    <Fade>
      <div className="flex-1 flex flex-col ">
        <ScrollSpy
          offsetTop={200}
          offsetBottom={100}
          scrollThrottle={50}
          useBoxMethod
        >
          <Profile />
          <Experience />
          <Education />
          <Training />
          <Skills />
        </ScrollSpy>
      </div>
    </Fade>
  );
}
